export enum PaymentFlowType {
  RegularOffer = 'RegularOffer',
  SplitBooking = 'SplitBooking',
  ExistingBooking = 'ExistingBooking'
}
